// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard___2m8tV","tooltipContainer":"tooltipContainer___3_bFq"};